import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const SYNC_USER_PROFILES = getApplicationStateIdentifier();

export const ADMIN = getApplicationStateIdentifier({
  SYNC_USER_PROFILES,
});
